(function () {
  'use strict';

  function productUrl() {
    var canonical = document.querySelector('link[rel="canonical"]');
    if (canonical && canonical.href) {
      try {
        return new URL(canonical.href, window.location.origin).pathname;
      } catch (error) {}
    }
    return window.location.pathname.split('?')[0];
  }

  function exposeSelectedVariant(root) {
    if (!root) return;

    var variantInput =
      root.querySelector('product-form form[action*="/cart/add"] [name="id"]') ||
      root.querySelector('form[action*="/cart/add"] [name="id"]');

    if (variantInput) {
      variantInput.setAttribute('data-simple-variant', '');
    }
  }

  function rescan() {
    if (window.BigsmallShortlist && typeof window.BigsmallShortlist.scan === 'function') {
      window.BigsmallShortlist.scan();
    }
  }

  function inject() {
    if (!/^\/products\//.test(window.location.pathname)) return;

    var root =
      document.querySelector('section[id^="MainProduct-"]') ||
      document.querySelector('.product');

    if (!root) return;

    exposeSelectedVariant(root);

    if (document.querySelector('.bs-shortlist-product-control')) {
      rescan();
      return;
    }

    var target =
      root.querySelector('.product-form__buttons') ||
      root.querySelector('product-form') ||
      root.querySelector('.product-form');

    if (!target) return;

    var holder = document.createElement('div');
    holder.className = 'bs-shortlist-product-control';

    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'bs-shortlist-add';
    button.dataset.bsAddUrl = productUrl();
    button.dataset.bsContext = 'product';
    button.setAttribute('aria-pressed', 'false');
    button.textContent = 'Add to Shortlist';

    holder.appendChild(button);
    target.insertAdjacentElement('afterend', holder);
    rescan();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', inject, { once: true });
  } else {
    inject();
  }

  document.addEventListener('shopify:section:load', inject);
})();
